export default __webpack_public_path__ + "static/media/ButtonStartAgain.90f7a4db.png";